
export const positionX = (redius, angle) => (
  redius*Math.cos(angle)
)

export const positionY = (redius, angle) => (
  redius*Math.sin(angle)
)

export const angleNumber = (page, children, root) => {
  if(typeof children === 'undefined'){
    return 0
  }
  if ((page + 12) <= children.length) {
    return( 6 )
  } else if(root) {
    return( (children.length - page)/2 )
  }
  return( (children.length + 1 - page)/2 )
}

export const parentNumber = number => (
  number.slice(0,number.lastIndexOf('.')) || number
)

export const numberOfNodes = (page, children, root) => {
  if(typeof children === 'undefined'){
    return 0
  }
  let current = (children.length - page)
  if ( current >= 12) {
    if(root){ return(12)} else { return(11) }
  }
  if( current < 0 ) {
    return 0
  }
  return ( current )
}

export const idx = number => (
  Number(number.slice(number.lastIndexOf('.')+1)) % 12
)

export const angleValue = (x1, y1, x2, y2) => (
  Math.atan2(y2 - y1, x2 - x1)
)

export const pageNumber = root => {
  return root ? 11 : 10
}

export const fixedNode = id => (
  (id.indexOf('sign_up') === 0) ||
  (id.indexOf('login') === 0) ||
  (id.indexOf('my') === 0)
)

export const escapeHtml = text => (
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\\/g, '\\\\')
    .replace(/\//g, '\\/')
    .replace(/\r?\n/g, '<br>')
)

export const escapeJS = text => (
  text
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\\\\/g, '\\')
    .replace(/\//g, '\/')
    .replace(/<br>/g, '\n')
)

export const convertText = text =>{
  return text.replace(/<a href='(.*?)' target='_blank'>|<\/a>|<br>/g, '').substr( 0, 10)
}



// WEBPACK FOOTER //
// ./src/common/node.js